export default () => {
    const cache = { ...sessionStorage }
    Object.keys(cache).forEach(key => cache[key] = isNaN(cache[key]) ? cache[key] : Number(cache[key]))
    return cache
}